import { SystemStyleObject } from "@chakra-ui/react";

export const LexicalClassNames = {
    LTR: 'lexical-ltr',
    RTL: 'lexical-rtl',
    CODE: 'lexical-code',
    H1: 'lexical-h1',
    H2: 'lexical-h2',
    H3: 'lexical-h3',
    BOLD: 'lexical-bold',
    ITALIC: 'lexical-italic',
    UNDERLINE: 'lexical-underline',
    STRIKETHROUGH: 'lexical-strikethrough',
    UNDERLINE_STRIKETHROUGH: 'lexical-underline-strikethrough',
    LIST_ITEM: 'lexical-listitem',
    NESTED_LI: 'lexical-nested-listitem',
    OL1: 'lexical-ol1',
    OL2: 'lexical-ol2',
    OL3: 'lexical-ol3',
    OL4: 'lexical-ol4',
    OL5: 'lexical-ol5',
    LINK: 'lexical-link',
}

function cssClassName(name: string) {
    return `.${name}`
}

export const lexicalStyles: Record<string, SystemStyleObject> = {
    [cssClassName(LexicalClassNames.LTR)]: {
        textAlign: 'left'
    },
    [cssClassName(LexicalClassNames.RTL)]: {
        textAlign: 'right'
    },
    [cssClassName(LexicalClassNames.CODE)]: {
        backgroundColor: 'rgb(240, 242, 245)',
        display: 'block',
        lineHeight: 1.5,
        padding: "8px",
        margin: 0,
        marginTop: "8px",
        marginBottom: "8px",
        overflowX: 'auto',
        tabSize: 2,
    },
    [cssClassName(LexicalClassNames.H1)]: {
        fontSize: 26,
        fontWeight: 400,
        margin: 0,
    },
    [cssClassName(LexicalClassNames.H2)]: {
        fontSize: 24,
        fontWeight: 400,
        margin: 0,
    },
    [cssClassName(LexicalClassNames.H3)]: {
        fontSize: 20,
        fontWeight: 400,
        margin: 0,
    },
    [cssClassName(LexicalClassNames.BOLD)]: {
        fontWeight: 'bold',
    },
    [cssClassName(LexicalClassNames.ITALIC)]: {
        fontStyle: 'italic',
    },
    [cssClassName(LexicalClassNames.UNDERLINE)]: {
        textDecoration: 'underline',
    },
    [cssClassName(LexicalClassNames.STRIKETHROUGH)]: {
        textDecoration: 'line-through',
    },
    [cssClassName(LexicalClassNames.UNDERLINE_STRIKETHROUGH)]: {
        textDecoration: 'underline line-through',
    },
    [cssClassName(LexicalClassNames.LIST_ITEM)]: {
        marginLeft: '16px',
    },
    [cssClassName(LexicalClassNames.NESTED_LI)]: {
        listStyleType: 'none',
        _before: {
            display: 'none'
        },
        _after: {
            display: 'none',
        }
    },
    [cssClassName(LexicalClassNames.OL1)]: {
        padding: 0,
        margin: 0,
        listStylePosition: 'outside',
    },
    [cssClassName(LexicalClassNames.OL2)]: {
        padding: 0,
        margin: 0,
        listStyleType: 'upper-alpha',
        listStylePosition: 'outside',

    },
    [cssClassName(LexicalClassNames.OL3)]: {
        padding: 0,
        margin: 0,
        listStyleType: 'lower-alpha',
        listStylePosition: 'outside',

    },
    [cssClassName(LexicalClassNames.OL4)]: {
        padding: 0,
        margin: 0,
        listStyleType: 'upper-roman',
        listStylePosition: 'outside',

    },
    [cssClassName(LexicalClassNames.OL5)]: {
        padding: 0,
        margin: 0,
        listStyleType: 'lower-roman',
        listStylePosition: 'outside',

    },
    [cssClassName(LexicalClassNames.LINK)]: {  
        color: 'rgb(33, 111, 219)',
        textDecoration: 'none',
        _hover: {
            textDecoration: 'underline',
            cursor: 'pointer',
        }
    }
}